/**
 * Personas list route — eagerly registers the file route, but defers
 * the component + atom imports via `.lazy.tsx`. Keeps the personas-list
 * admin chunk out of the bundle for non-admin users.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/flirtmachine/_authenticated/admin/personas")({});
